import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../../types/analytics';
import { IBetPosition } from '../../../../../../../types/reducers/betPosition';
import {
  TExperimentsGroups,
  TServicesCardsTextsExperimentGroupsNames,
} from '../../../../../../../constants/experiments';

interface ITrackServicesShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  analyticsFormId: string;
  serviceIds: Array<EServiceId>;
  activeServiceId: EServiceId;
  bet: number | null;
  betPosition: IBetPosition | null;
  testGroupName: TExperimentsGroups;
}

type EventType = { [key in TServicesCardsTextsExperimentGroupsNames]: string };

const eventType: EventType = {
  a_default: 'fvu_newest',
  b_views: 'fvu_newest_koeff_views',
  c_shows: 'fvu_newest_koeff_shows',
  d_redesign: 'fvu_newest_redesign',
};

export const trackServicesShow = (params: ITrackServicesShowParams) => {
  const {
    analyticsOfferStatus,
    analyticsProduct,
    serviceIds,
    betPosition,
    bet,
    activeServiceId,
    analyticsFormId,
    testGroupName,
  } = params;

  let eventTypeParam = eventType.a_default;

  if (testGroupName in eventType) {
    eventTypeParam = eventType[testGroupName as TServicesCardsTextsExperimentGroupsNames];
  }

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: serviceIds.join('/'),
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: eventTypeParam,
        vas: activeServiceId,
        bid: bet,
        position: betPosition?.offerPosition,
        page_number: betPosition?.page,
        form_id: analyticsFormId,
      },
    },
  });
};

interface ITrackSliderScrollParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  direction: string;
  analyticsFormId: string;
}

export const trackSliderScroll = (params: ITrackSliderScrollParams) => {
  const { analyticsOfferStatus, analyticsProduct, direction, analyticsFormId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_scroll',
    label: direction,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: analyticsFormId,
      },
    },
  });
};

interface ITrackDiffPricingShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsFormId: string;
  diffPriceIterationId: string | null;
  diffPriceGranuleGuid: string | null;
}

export const trackDiffPricingShow = (params: ITrackDiffPricingShowParams) => {
  const { analyticsOfferStatus, analyticsFormId, diffPriceIterationId, diffPriceGranuleGuid } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'show_diff_pricing',
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: analyticsFormId,
        diffPriceGranuleGuid,
        diffPriceIterationId,
      },
    },
  });
};
